import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceAction } from '../../../domain/enums/invoice-action.enum';
import { InvoiceActionRule } from '../../../domain/models/invoice-action-rule.model';

@Component({
  selector: 'app-invoice-action-buttons',
  templateUrl: './invoice-action-buttons.component.html',
  styleUrls: ['./invoice-action-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceActionButtonsComponent {
  @Input({ required: true }) actions!: readonly InvoiceActionRule[];
  /** Controls mobile visibility via CSS class. On desktop buttons are always visible. */
  @Input() visible = true;
  /** Action currently waiting for a backend response. Disables all buttons and shows a spinner on the matching one. */
  @Input() loadingAction: InvoiceAction | null = null;
  @Output() readonly actionSelected = new EventEmitter<InvoiceAction>();

  isLoading(rule: InvoiceActionRule): boolean {
    return this.loadingAction === rule.action;
  }

  isDisabled(rule: InvoiceActionRule): boolean {
    return !rule.enabled || this.loadingAction !== null;
  }

  onSelect(rule: InvoiceActionRule): void {
    if (rule.enabled && this.loadingAction === null) {
      this.actionSelected.emit(rule.action);
    }
  }

  trackAction(_: number, rule: InvoiceActionRule): InvoiceAction {
    return rule.action;
  }
}
